import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-niskayuna-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-niskayuna-ny", statusCode: 301 });
  },
});
